import React from 'react';
import intl from 'react-intl-universal';
import {observer} from 'mobx-react-lite';

import type {AppState} from '@stores/AppState';
import type {RoleSummary} from '@stores/rbac/AccessRolesController';

import {editRole} from '../../../../actions/rbac/editRole';
import {deleteRole} from '../../../../actions/rbac/deleteRole';
import {useCrudServices} from '../../../../platform/hooks/useServiceCombinations';
import {ContextMenu} from '../../../components/ContextMenu/ContextMenu';
import {DeleteIcon} from '../../../components/icons/DeleteIcon';
import {EditIcon} from '../../../components/icons/editor/EditIcon';
import {useAppState} from '@stores/AppStateContext';
import {ContextMenuInterface} from '../ContextMenuInterface';

export interface AccessRoleRowOptionsProps extends ContextMenuInterface {
    summary: RoleSummary;
}

export const openAccessRoleRowOptions = (
    appState: AppState,
    summary: RoleSummary,
    event: React.MouseEvent
) => {
    appState.setContextMenu({
        id: `access-role-row-options-${summary.role.id}`,
        type: 'access-role-row-options',
        clientX: event.clientX,
        clientY: event.clientY,
        withOverlay: true,
        minWidth: 180,
        params: {summary},
    });
};

export const AccessRoleRowOptions = observer(({handleClose, isDark, summary}: AccessRoleRowOptionsProps) => {
    const appState = useAppState();
    const services = useCrudServices();
    const role = summary.role;

    return (
        <ContextMenu
            isDark={isDark}
            handleClose={handleClose}
            items={[
                {
                    text: intl.get('common.edit').d('Edit'),
                    Icon: EditIcon,
                    onClick: () => {
                        appState.setContextMenu(null);
                        editRole(appState, role.id, summary);
                    },
                },
                {
                    text: intl.get('common.delete').d('Delete'),
                    Icon: DeleteIcon,
                    onClick: () => {
                        appState.setContextMenu(null);
                        deleteRole(services, appState, role.id, role.displayName);
                    },
                },
            ]}
        />
    );
});
